import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PageLayout from "examples/LayoutContainers/PageLayout";

function CoverLayout({ header, title, description, image, children }) {
  return (
    <PageLayout background="white">
      <Grid
        container
        alignItems="stretch"
        sx={{
          minHeight: "100vh",
          margin: 0,
          background: "#F6F9FC",
        }}
      >
        <Grid
          item
          xs={12}
          md={6}
          lg={5}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: { xs: 2, sm: 4, md: 5 },
          }}
        >
          <SoftBox
            sx={{
              width: "100%",
              maxWidth: 460,
              background: "#fff",
              border: "1px solid #E2E8F0",
              borderRadius: "22px",
              boxShadow: "0 20px 60px rgba(15,23,42,.08)",
              overflow: "hidden",
            }}
          >
            <SoftBox
              sx={{
                height: 6,
                background: "linear-gradient(90deg, #0284C7 0%, #38BDF8 100%)",
              }}
            />
            <SoftBox pt={4} px={4}>
              {!header ? (
                <>
                  <SoftBox mb={1}>
                    <SoftTypography
                      variant="h3"
                      fontWeight="bold"
                      sx={{ color: "#0F172A", fontSize: { xs: "1.7rem", sm: "2rem" } }}
                    >
                      {title}
                    </SoftTypography>
                  </SoftBox>
                  <SoftTypography variant="body2" fontWeight="regular" sx={{ color: "#64748B" }}>
                    {description}
                  </SoftTypography>
                </>
              ) : (
                header
              )}
            </SoftBox>
            <SoftBox p={4}>{children}</SoftBox>
          </SoftBox>
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          lg={7}
          sx={{
            display: { xs: "none", md: "block" },
            p: 2,
          }}
        >
          <SoftBox
            height="calc(100vh - 32px)"
            position="relative"
            sx={{
              overflow: "hidden",
              borderRadius: "24px",
              backgroundImage: `linear-gradient(135deg, rgba(2,132,199,.90), rgba(3,105,161,.76)), url(${image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              boxShadow: "0 24px 70px rgba(2,132,199,.18)",
            }}
          >
            <SoftBox
              sx={{
                position: "absolute",
                inset: 0,
                background: "radial-gradient(circle at 25% 20%, rgba(255,255,255,.20), transparent 38%)",
              }}
            />
          </SoftBox>
        </Grid>
      </Grid>
    </PageLayout>
  );
}

CoverLayout.defaultProps = {
  header: "",
  title: "",
  description: "",
  color: "info",
  top: 0,
};

CoverLayout.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark", "light"]),
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string.isRequired,
  top: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export default CoverLayout;
